import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import mainApi from '../../redux/apis/main-api';

import SvgIcon from '../svg-icon/svg-icon.component';
import './SideBar.styles.scss';

const SideBar = ({ handleClose, children }) => {
	useEffect(() => {
		document.body.style.top = `-${window.scrollY}px`;
		document.body.style.width = '100%';
		document.body.style.position = 'fixed';

		//dispatch(setCanScroll(false));

		return () => {
			const scrollY = document.body.style.top;
			document.body.style.position = '';
			document.body.style.top = '';
			window.scrollTo(0, parseInt(scrollY || '0') * -1);
		};
	}, []);

	return (
		<>
			<motion.div
				initial={{ opacity: 0, translateX: 20 }}
				animate={{ opacity: 1, translateX: 0 }}
				exit={{ opacity: 0, translateX: 20 }}
				transition={{ duration: 0.2 }}
				className="search-side-bar-container"
			>
				<div className="close" onClick={() => handleClose()}>
					<SvgIcon icon="icon-ios-close-empty" />
				</div>
				{children}
			</motion.div>
			<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="backdrop" onClick={() => handleClose()} />
		</>
	);
};

export default SideBar;
